export const MUSICAL_GENRES_UPDATED_EVENT = 'musical-genres:updated'

export function notifyMusicalGenresUpdated() {
  window.dispatchEvent(new Event(MUSICAL_GENRES_UPDATED_EVENT))
}
